import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/RecruitIntern.module.css';
import WireframeBackground from '../components/WireframeBackground';

function InternRecruit() {
    return (
        <div className={styles.container}>
            <WireframeBackground />
            <div className={styles.wrap}>
                <section className={styles.recruitSection}>
                    <div className={styles.header}>
                        <h1 className={styles.sectionTitle}>FOR SCHOOLS</h1>
                        <p className={styles.subtitle}>専門学校・教育機関の皆様へ</p>
                    </div>

                    <div className={styles.heroCard}>
                        <div className={styles.cornerTL}></div>
                        <div className={styles.cornerTR}></div>
                        <div className={styles.cornerBL}></div>
                        <div className={styles.cornerBR}></div>
                        <div className={styles.heroContent}>
                            <h2 className={styles.heroTitle}>リグの特別授業を開催しませんか？</h2>
                            <p className={styles.heroText}>
                                私たちParnasは、「全てのデジタルアセットに命を吹き込む」というビジョンを掲げ、リギング技術に特化したプロフェッショナル集団です。<br />
                                リギングは、ゲーム、アニメ、広告コンテンツの品質を左右する横断的な専門スキルですが、その専門的な知見を持つ人材の育成は多くの教育機関で課題となっています。
                            </p>
                            <p className={styles.heroText}>
                                Parnasは、完全リモート体制で全国の優秀なクリエイターを結集する企業運営のノウハウを活かし、「学校と企業が一体となった次世代リガー育成」をサポートいたします。<br />
                                ご要望に応じた柔軟な連携プログラムにより、貴校の教育活動と学生のキャリア形成を強力に支援します。
                            </p>
                        </div>
                    </div>

                    <div className={styles.content}>
                        {/* 特別授業実績セクション */}
                        <div className={styles.infoCard}>
                            <div className={styles.cornerTL}></div>
                            <div className={styles.cornerTR}></div>
                            <div className={styles.cornerBL}></div>
                            <div className={styles.cornerBR}></div>

                            <h3 className={styles.title}>リグ特別授業実績</h3>
                            <div className={styles.achievementList}>
                                <a href="https://www.neec.ac.jp/" target="_blank" rel="noopener noreferrer" className={styles.achievementItem}>日本工学院蒲田校</a>
                                <a href="https://www.kobedenshi.ac.jp/" target="_blank" rel="noopener noreferrer" className={styles.achievementItem}>神戸電子専門学校</a>
                                <a href="https://ha.athuman.com/?code=240051&utm_source=google&utm_medium=cpc&utm_campaign=brand&utm_term=all&network=google_g&placement=&keyword=%E3%83%92%E3%83%A5%E3%83%BC%E3%83%9E%E3%83%B3%20%E3%82%A2%E3%82%AB%E3%83%87%E3%83%9F%E3%83%BC%20%E7%A5%9E%E6%88%B8%20%E6%A0%A1&device=&gad_source=1&gad_campaignid=1646784363&gbraid=0AAAAAD-EwcTmFdyajf8koXSfRpnaqMnoN&gclid=CjwKCAiAnoXNBhAZEiwAnItcG6U9ZLG8WaTuRJEirXp8RAzx-Uqeosex4ioEAA_BI4ueUp86438ZBxoCOkMQAvD_BwE" target="_blank" rel="noopener noreferrer" className={styles.achievementItem}>総合学園ヒューマンアカデミー神戸三宮校</a>
                                {/* <a href="https://www.wakayama-u.ac.jp/" target="_blank" rel="noopener noreferrer" className={styles.achievementItem}>和歌山大学映像制作CG学科</a> */}
                            </div>
                        </div>

                        <div className={styles.infoCard}>
                            <div className={styles.cornerTL}></div>
                            <div className={styles.cornerTR}></div>
                            <div className={styles.cornerBL}></div>
                            <div className={styles.cornerBR}></div>

                            <h3 className={styles.title}>課題・ニーズへのご提案</h3>
                            <table className={styles.recruitTable}>
                                <thead>
                                    <tr>
                                        <th style={{ width: '25%' }}>課題・ニーズ</th>
                                        <th style={{ width: '50%' }}>Parnasからのご提案</th>
                                        <th style={{ width: '25%' }}>貴校へのメリット</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>リグの専門講師が見つからない</th>
                                        <td><strong>【特別授業の提供】</strong> 現役のリギングアーティストによる、最新の実務に即した特別授業（オンライン）を企画・実施いたします。</td>
                                        <td>貴校のカリキュラムに専門性の高い「リグ」の分野を安定的に組み込めます。</td>
                                    </tr>
                                    <tr>
                                        <th>現役のプロから話を聞きたい</th>
                                        <td><strong>【オンライン講演会・座談会】</strong> 学生からの質問に答える形式でのオンライン講演会や、現役リガーとの座談会を実施し、現場のリアルをお伝えします。</td>
                                        <td>学生のモチベーション向上と、具体的なキャリアパスのイメージ形成を支援します。</td>
                                    </tr>
                                    <tr>
                                        <th>インターン時期・内容を調整したい</th>
                                        <td><strong>【対象年次の広さ】</strong> 個別の学校のスケジュールに合わせることはできかねますが、インターン対象に翌年度の就活生・既卒生を含めています。</td>
                                        <td>より多くの学生に参加いただくことが可能です。</td>
                                    </tr>
                                    <tr>
                                        <th>就職説明会・企業説明会を実施したい</th>
                                        <td><strong>【個別企業説明会の開催】</strong> 実施経験豊富な社員が、貴校の学生向けに企業の事業内容、技術、募集要項を詳細にご説明いたします。</td>
                                        <td>学生の就職活動における企業研究をサポートし、就職先の選択肢を明確に提示できます。</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className={styles.infoCard}>
                            <div className={styles.cornerTL}></div>
                            <div className={styles.cornerTR}></div>
                            <div className={styles.cornerBL}></div>
                            <div className={styles.cornerBR}></div>

                            <h3 className={styles.title}>Parnasで得られる「クリエイターとしての未来」</h3>
                            <p className={styles.description}>貴校の学生が卒業後に目指すことができる、Parnasでの働き方と育成環境をご紹介します。</p>

                            <table className={styles.recruitTable}>
                                <tbody>
                                    <tr>
                                        <th>育成体制</th>
                                        <td><strong>体系化された教育プログラム：</strong>未経験採用の場合、入社後約半年間の集中研修とOJTを通じて、プロフェッショナルなリガーへと計画的に育成します。</td>
                                    </tr>
                                    <tr>
                                        <th>勤務環境</th>
                                        <td><strong>完全フルリモート：</strong>物理的な制約から解放され、全国どこからでも最高のパフォーマンスを発揮できます。地元を離れられない学生の就職を応援します。</td>
                                    </tr>
                                    <tr>
                                        <th>ワークライフバランス</th>
                                        <td><strong>徹底した残業管理：</strong>土日勤務・深夜残業は原則禁止。メンバー一丸となってメリハリある働き方作りを目指しています。</td>
                                    </tr>
                                    <tr>
                                        <th>キャリア</th>
                                        <td><strong>特化した専門性：</strong>日本で数少ないリグ専門企業として、社内・他社仕様など多様なプロジェクトを通じて、圧倒的な数の実力向上の機会が常に用意されています。</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className={styles.infoCard}>
                            <div className={styles.cornerTL}></div>
                            <div className={styles.cornerTR}></div>
                            <div className={styles.cornerBL}></div>
                            <div className={styles.cornerBR}></div>

                            <h3 className={styles.title}>お問い合わせ</h3>
                            <p className={styles.description}>連携プログラムに関するご相談、会社説明会のご依頼など、お気軽にお問い合わせください。</p>
                            <div className={styles.buttonWrapper}>
                                <Link to="/contact" className={styles.contactButton}>お問い合わせへ</Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default InternRecruit;
